import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', { 
    day: '2-digit', 
    month: 'short', 
    year: 'numeric',
    timeZone: 'Europe/London'
  });
};

export const isOverdue = (dueDateString) => {
  if (!dueDateString) return false;
  const dueDate = new Date(dueDateString);
  const today = new Date();
  return today > dueDate;
};

export const getPaymentStructureLabel = (structure) => {
  const labels = {
    'full_upfront': '100% upfront',
    'fifty_fifty': '50/50 split',
    'three_month_milestones': 'Monthly instalments',
    'credit_card': 'Credit Card',
    'bnpl': 'BNPL (Buy Now, Pay Later)',
    'invoice': 'Invoice'
  };
  return labels[structure] || structure;
};

export const copyToClipboard = (text, toast, message) => {
  navigator.clipboard.writeText(text);
  toast({
    title: "Copied",
    description: message
  });
};

export const calculateVATInclusiveAmount = (netAmount, vatRate, vatEnabled) => {
  if (!vatEnabled) return netAmount;
  const vatAmount = netAmount * (vatRate / 100);
  return netAmount + vatAmount;
};

export const sendEmail = async (emailData, toast) => {
  try {
    await axios.post(`${API}/send-email`, {
      to: emailData.to,
      subject: emailData.subject,
      template: emailData.template,
      project_id: emailData.project_id,
      payment_url: emailData.payment_url,
      email_type: emailData.email_type || 'payment_link'
    }, {
      headers: { 
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    
    toast({
      title: "Email Sent!",
      description: `Successfully sent to ${emailData.to} from your business email`
    });
    
    return true;
  } catch (error) {
    toast({
      title: "Email Failed",
      description: error.response?.data?.detail || "Failed to send email. Please check your business email configuration in Settings.",
      variant: "destructive"
    });
    
    return false;
  }
};
